<template>
  <div class="problem">
    <div class="topTitle">
      <span style="cursor: pointer;" @click="goback">返回</span> / 新增比赛
    </div>
    <div class="mian">
      <div>
        <el-button type="primary" @click="add" icon="el-icon-plus">新增问题</el-button>
        <el-button type="primary">从公共库导入</el-button>
        <el-button type="primary">从比赛库导入</el-button>
      </div>
      <el-table :data="tableData" stripe style="width: 100%;margin-top: 20px;" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column prop="id" label="序号">
        </el-table-column>
        <el-table-column prop="Display_id" label="比赛题号">
        </el-table-column>
        <el-table-column prop="title" label="问题名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" label="创建时间">
        </el-table-column>
        <el-table-column prop="isActive" label="是否可见">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isActive" active-color="#409EFF" inactive-color="#ccc">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template>
            <el-button type="text" size="mini">编辑</el-button>
            <el-button type="text" size="mini">转为公共</el-button>
            <el-button type="text" size="mini">下载用例</el-button>
            <el-button type="text" size="mini">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      tableData: [
        {
          isActive: true
        }
      ]
    }
  },
  methods: {
    add() {
      this.$router.push({
        name: 'addQuestion'
      })
    },
    goback() {
      this.$router.go(-1)
    }
  }

}
  </script>
   <style lang="scss" scoped>
.problem {
  height: 100%;
  width: 100%;
}
.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  span {
    color: rgba(0, 0, 0, 0.45);
  }
}
.mian {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}
</style>